import React from "react";
import { useLocation } from "react-router-dom";

import BookmarkIcon from "@mui/icons-material/Bookmark";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import { Box, Button, Divider, Grid, Stack } from "@mui/material";
import { useModals } from "hooks";
import { IBookmark, IBookmarkType, UrlQueryParams } from "store/types";

import { CorrelationMatrixBookmark } from "./CorrelationMatrixBookmark";
import { DealBookmark } from "./DealBookmark";
import { DataOperationsBookmark } from "./DataOperationsBookmark";
import { QuickViewBookmark } from "./QuickViewBookmark";
import { ReportBookmark } from "./ReportBookmark";

interface Props {
  title: string;
  bookmarks: IBookmark[];
  shared?: boolean;
  closeBookmarksList?: () => void;
  saveButtonAvailable: null | {
    target: string;
    type: string;
  };
}

export const Group: React.FC<Props> = ({ title, bookmarks, shared, closeBookmarksList, saveButtonAvailable }) => {
  const { pathname } = useLocation();
  const { saveViewModal } = useModals();

  return (
    <Box>
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          mb: "9px",
          color: "#0a3142"
        }}
      >
        <Stack sx={{ flexDirection: "row", alignItems: "center", fontWeight: 700, fontSize: "16px" }}>
          {!shared ? (
            <BookmarkIcon sx={{ marginRight: "10px", width: "20px" }} />
          ) : (
            <PublicOutlinedIcon sx={{ marginRight: "10px", width: "20px" }} />
          )}
          {title}
        </Stack>
        {!shared && saveButtonAvailable && (
          <Button
            onClick={() => {
              closeBookmarksList && closeBookmarksList();
              saveViewModal({
                isOpen: true,
                target: saveButtonAvailable?.target as keyof UrlQueryParams,
                type: saveButtonAvailable?.type as IBookmarkType,
                currentLocation: pathname
              });
            }}
            variant="contained"
          >
            + Save View
          </Button>
        )}
      </Stack>
      <Divider sx={{ color: "#dae0e2", marginBottom: "5px" }} />
      <Stack justifyContent="center">
        {!!bookmarks.length && (
          <Grid container spacing={2} sx={{ color: "#0a3142", padding: "10px 0", fontWeight: 500, fontSize: 15 }}>
            <Grid item xs={2}>
              Type
            </Grid>
            <Grid item xs={7}>
              Name
            </Grid>
            <Grid item xs={3}>
              {shared && <>Owner</>}
            </Grid>
          </Grid>
        )}
        {bookmarks.map(
          (bookmark) =>
            (bookmark.type === "quick_view" && <QuickViewBookmark key={bookmark.id} {...bookmark} />) ||
            (bookmark.type === "deal" && <DealBookmark key={bookmark.id} {...bookmark} />) ||
            (bookmark.type === "investor_view" && <DealBookmark key={bookmark.id} {...bookmark} />) ||
            (bookmark.type === "report" && <ReportBookmark key={bookmark.id} {...bookmark} />) ||
            (bookmark.type === "correlation_matrix" && <CorrelationMatrixBookmark key={bookmark.id} {...bookmark} />) ||
            (bookmark.type === "data_operations" && <DataOperationsBookmark key={bookmark.id} {...bookmark} />)
        )}
      </Stack>
    </Box>
  );
};
